var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
import { html } from 'lit';
import { SdsContextMenuItem } from './sds-cm-item.lit';
import { sdsCustomElement } from '../../utilities/custom-components';
let SdsContextMenuExpandableItem = (() => {
    let _classDecorators = [sdsCustomElement('sds-cm-expandable-item')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsContextMenuItem;
    var SdsContextMenuExpandableItem = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            this.hide = () => {
                this.hideMenu();
            };
            this.toggleMenu = () => {
                const menu = this.getMenu();
                if (menu) {
                    menu.opened ? menu.hide() : menu.show(this);
                }
            };
            this.showMenu = () => {
                if (this._closeTimeout) {
                    clearTimeout(this._closeTimeout);
                    this._closeTimeout = undefined;
                }
                else {
                    const menu = this.getMenu();
                    if (menu && !menu.opened) {
                        menu.show(this);
                    }
                }
            };
            this.hideMenu = () => {
                const menu = this.getMenu();
                if (menu && menu.opened && !this._closeTimeout) {
                    this._closeTimeout = setTimeout(() => {
                        menu.hide();
                        this._closeTimeout = undefined;
                    }, 150);
                }
            };
        }
        render() {
            return this.renderInWrapper(html `
                ${this.renderIcon()}
                <div class="sds-cm-item__content" aria-label="${this.name}, has submenu">
                    ${this.renderName()} ${this.renderDescription()}
                </div>
                ${this.renderExpandIcon()} ${this.renderNestedContextMenu()}
            `);
        }
        getMenu() {
            var _a;
            return (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('sds-context-menu');
        }
        connectedCallback() {
            super.connectedCallback();
            this.addEventListener('mouseover', this.showMenu);
            this.addEventListener('mouseleave', this.hideMenu);
        }
        disconnectedCallback() {
            this.hideMenu();
            this.removeEventListener('mouseover', this.showMenu);
            this.removeEventListener('mouseleave', this.hideMenu);
            super.disconnectedCallback();
        }
        renderExpandIcon() {
            return html `
            <sds-icon
                class="sds-cm-item__nested-arrow"
                size="16"
                name="arrow_right_small"
            ></sds-icon>
        `;
        }
        renderNestedContextMenu() {
            return html `
            <sds-context-menu class="sds-nested-context-menu" position="beside" offset="4">
                <slot></slot>
            </sds-context-menu>
        `;
        }
    };
    __setFunctionName(_classThis, "SdsContextMenuExpandableItem");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsContextMenuExpandableItem = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsContextMenuExpandableItem = _classThis;
})();
export { SdsContextMenuExpandableItem };
